import React from "react";
import { Link } from "react-router-dom";
import { FaRegHeart, FaHeart } from "react-icons/fa6";
import { RiReplyLine } from "react-icons/ri";
import Moment from "react-moment";
import { handleErrorImg, handleFormatNumber } from "../../../../../service/utils/utils";
import config from "../../../../../configs/Configs.json";
import AVATAR_DEFAULT from "../../../../../images/avatar-default.jpg";

const { IMAGE_POST_PLACEHOLDER } = config;

function PostContent({ postData, onLike, onReply }) {
    if (!postData) return null;

    return (
        <div className="w-full">
            <div className="rounded-md overflow-hidden">
                {/* Header */}
                <div className="w-full py-2 px-1 backdrop:blur-md flex bg-[#1da57a] justify-between text-black">
                    <Moment locale="VN" format="hh:mm DD/MM/YYYY" fromNow>
                        {`${postData?.UpdatePostAt}+0700`}
                    </Moment>
                    <h3>#1</h3>
                </div>

                <div className="border-x border-b border-solid border-white rounded-b-md overflow-hidden">
                    {/* Author Info */}
                    <Link to={`/profile/${postData?.UserName}`}>
                        <div className="w-full border-b border-solid border-white p-4">
                            <div className="w-full h-auto flex justify-start items-center">
                                <img
                                    src={postData?.Avatar || AVATAR_DEFAULT}
                                    alt="avatar"
                                    className="w-1/12 aspect-square mr-3 object-cover"
                                    onError={(e) => handleErrorImg(e.target)}
                                />
                                <div>
                                    <h1 className="text-xl font-bold w-full">{postData?.UserFullName}</h1>
                                </div>
                            </div>
                        </div>
                    </Link>

                    {/* Post Content */}
                    <div className="p-4 relative">
                        <div
                            className="post-content whitespace-pre-line"
                            dangerouslySetInnerHTML={{ __html: postData?.Content || "" }}
                        />

                        {/* Post Images */}
                        {Array.isArray(postData?.Photo) &&
                            postData?.Photo.length > 0 &&
                            postData?.Photo.map((item, i) => (
                                <div key={i} className="w-full h-[70vh] backdrop:blur-md bg-black/80 rounded-lg">
                                    <img
                                        src={item || IMAGE_POST_PLACEHOLDER}
                                        alt="post"
                                        className="h-full mx-auto object-contain"
                                        onError={(e) => handleErrorImg(e.target)}
                                    />
                                </div>
                            ))}

                        {/* Actions */}
                        <div className="w-full pt-3 flex gap-2 justify-between items-center">
                            {/* Like Button */}
                            <div className="pt-3 flex gap-2 items-center text-md">
                                {!postData?.favoriteType ? (
                                    <FaRegHeart
                                        className="text-white cursor-pointer"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            onLike && onLike();
                                        }}
                                    />
                                ) : (
                                    <FaHeart
                                        className="text-red-500 cursor-pointer"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            onLike && onLike();
                                        }}
                                    />
                                )}
                                {handleFormatNumber(postData?.FavoriteCount)}
                            </div>

                            {/* Reply Button */}
                            <div
                                className="p-2 flex gap-1 text-sm font-medium items-center cursor-pointer"
                                onClick={onReply}
                            >
                                <RiReplyLine />
                                <p>Trả lời</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PostContent;

